import {
    consulta,
    generarFiltros,
    formulario,
    crear_form_data,
} from '../../../../global/js/funciones';


/** Estados con conteos por periodo. */
export const fetchEstadosSolicitudesBienestar = (periodo, scope = 0) => new Promise((resolve) => {
    if (!periodo) {
        resolve({ error: 'invalid_periodo', estado: 400, resp: null });
        return;
    }
    const url = `api/v1.0/bienestar_estudiantil/estados/${periodo}?scope=${scope}`;
    consulta(url, null, null, (error, estado, resp) => {
        resolve({ error, estado, resp });
    });
});


/** Solicitudes filtradas para administrar bienestar. */
export const fetchSolicitudesBienestarAdmin = async (filtros = [], scope = 0) => {
    let f = await generarFiltros(filtros);
    if (f && f.startsWith('&')) f = f.substring(1);
    return new Promise((resolve) => {
        const qs = f && f.length > 0 ? `?${f}` : '';
        const url = `api/v1.0/bienestar_estudiantil/listar/${scope}${qs}`;
        consulta(url, null, null, (error, estado, resp) => {
            if (estado === 200 && !error && Array.isArray(resp)) {
                resolve(resp);
            } else {
                resolve([]);
            }
        });
    });
};


/** Gestionar proceso de bienestar. */
export const postGestionarProcesoBienestar = async (bienestarId, data) => {
    const form = await crear_form_data(data);
    return new Promise((resolve) => {
        formulario(
            `api/v1.0/bienestar_estudiantil/${bienestarId}/gestionar_proceso`,
            form,
            'post',
            (error, estado, resp) => {
                resolve({ error, estado, resp });
            },
        );
    });
};


/** Crear observacion en bienestar. */
export const postCrearObservacionBienestar = async (bienestarId, data) => {
    const form = await crear_form_data(data);
    return new Promise((resolve) => {
        formulario(
            `api/v1.0/bienestar/${bienestarId}/observaciones/crear`,
            form,
            'post',
            (error, estado, resp) => {
                resolve({ error, estado, resp });
            },
        );
    });
};


/**Estado del horario de recepción de solicitudes. */
export const fetchHorarioAtencion = () => new Promise((resolve) => {
    consulta('api/v1.0/bienestar_estudiantil/horario_atencion', null, 'get', (error, estado, resp) => {
        resolve(!error && estado === 200 ? resp : null);
    });
});


/** Guarda la semana completa del horario. Solo perfiles que administran. */
export const postHorarioAtencion = (payload) => new Promise((resolve) => {
    consulta('api/v1.0/bienestar_estudiantil/horario_atencion', payload, 'post', (error, estado, resp) => {
        resolve({ error, estado, resp });
    });
});


/**
 * Estados a los que puede pasar la solicitud. A diferencia del endpoint genérico
 * de permisos, respeta la línea propia del servicio (crisis no pasa por Gestión
 * de contacto ni Agendado).
 */
export const fetchEstadosSiguienteBienestar = (bienestarId) => new Promise((resolve) => {
    consulta(
        `api/v1.0/bienestar/${bienestarId}/estados_siguiente`,
        null,
        null,
        (error, estado, resp) => {
            if (!error && estado === 200 && Array.isArray(resp?.estados_siguiente)) {
                resolve(resp.estados_siguiente);
                return;
            }
            resolve([]);
        },
    );
});


/**
 * Enciende o apaga el aviso de disentimiento de una solicitud.
 * El aviso se le muestra al estudiante al ingresar a EMMA, a través del sistema
 * general de notificaciones. `incluirTrasladoEps` solo importa al activar: exige
 * también el disentimiento de Traslado EPS antes de apagarse solo.
 */
export const postAvisoDisentimiento = (bienestarId, activar, incluirTrasladoEps = false) => new Promise((resolve) => {
    consulta(
        `api/v1.0/bienestar/${bienestarId}/aviso_disentimiento`,
        { activar, incluir_traslado_eps: incluirTrasladoEps },
        'post',
        (error, estado, resp) => {
            resolve({ error, estado, resp });
        },
    );
});
